import React, { useState } from "react"
import "./../../CompanysForm.css"

import { PaginationGrid } from "../../../../../../components/Common/PaginationGrid"
import MonitoredTable from "./MonitoredTable"
import MonitoredForm from "./MonitoredForm"

const MonitoredGrid = ({
  data,
  currentPage,
  setCurrentPage,
  showList,
  setShowList,
  totalPages,
  companySelected,
  setCompanySelected,
}) => {
  return (
    <>
      {showList ? (
        <>
          {!!data.length && (
            <>
              <MonitoredTable
                dataArray={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setCompanySelected={setCompanySelected}
                setShowList={setShowList}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      ) : (
        <MonitoredForm
          companySelected={companySelected}
          setCompanySelected={setCompanySelected}
          showList={showList}
          setShowList={setShowList}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  )
}

export default MonitoredGrid
